type ApiErrorType =
  'PersonMedGradering'
  | 'Teknisk'

export type ApiErrorResponse = {
  message: string
  status: number
  type: ApiErrorType
}

export class ApiError extends Error {

  type: ApiErrorType

  constructor(message: string, apiError: ApiErrorResponse) {
    super(`${message}: ${apiError.message} (${apiError.status})`)
    this.type = apiError.type
  }

}